module.exports = __webpack_public_path__ + "static/34-d08da1b9e441f305a13938d4ee6f4543.png";